import React, { useRef } from "react";

import "./version.css";

export function Version() {
	const NUMBER_OF_CLICKS = 5;
	const CLICK_TIMEOUT = 500;

	const version = process.env.PUBLIC_VERSION;

	const counter = useRef(0);
	const counterTimeout = useRef<number>();

	function openFeatures() {
		const searchParams = new URLSearchParams(window.location.search);

		searchParams.set("screen", "features");

		window.location.search = searchParams.toString();
	}

	function onClick() {
		if (counterTimeout.current) {
			window.clearTimeout(counterTimeout.current);
		}

		counter.current += 1;

		if (counter.current === NUMBER_OF_CLICKS) {
			openFeatures();
		}

		counterTimeout.current = window.setTimeout(() => {
			counter.current = 0;
		}, CLICK_TIMEOUT);
	}

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events
		<div tabIndex={0} className="version" onClick={onClick} role="button">
			{version}
		</div>
	);
}
